module.exports = __webpack_public_path__ + "static/media/arrow-right.489ae46f.svg";